export default __webpack_public_path__ + "static/media/news-6.5cb97b7e.jpg";